module.exports = __webpack_public_path__ + "img/img_14.50156915.png";